import { fetch } from '../../utils';
import Backend from '../../backend';

export const getUserData = async () => {
  return fetch(Backend.methodUrl('user-data'))
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
